import React from "react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuPortal,
	DropdownMenuSub,
	DropdownMenuSubContent,
	DropdownMenuSubTrigger,
	DropdownMenuTrigger,
} from "@/dentlab/src/components/ui/dropdown-menu";
import { Button } from "@/dentlab/src/components/ui/button";
import { FIELD_REGISTRY, FIELD_CATEGORIES } from "../field-registry";
import { Plus, ChevronDown } from "lucide-react";

interface FieldSelectorProps {
	availableFields: string[];
	onSelect: (fieldId: string) => void;
}

export const FieldSelector: React.FC<FieldSelectorProps> = ({
	availableFields,
	onSelect,
}) => {
	if (availableFields.length === 0) {
		return (
			<div className="text-sm text-gray-500 p-4 border border-dashed rounded-lg text-center">
				Alle verfügbaren Felder wurden bereits hinzugefügt.
			</div>
		);
	}
	return (
		<div className="space-y-3 p-4 bg-gray-50 rounded-lg">
			<div className="text-sm font-medium text-gray-700">
				Feld hinzufügen
			</div>

			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<Button
						variant="outline"
						className="w-full justify-between"
					>
						<span className="flex items-center gap-2">
							<Plus className="h-4 w-4" />
							Feld wählen...
						</span>
						<ChevronDown className="h-4 w-4 opacity-50" />
					</Button>
				</DropdownMenuTrigger>
				<DropdownMenuContent
					className="w-80 max-h-96 overflow-y-auto"
					align="start"
				>
					<DropdownMenuItem
						key="patient_select"
						onClick={() => onSelect("patient_select")}
						className="cursor-pointer"
					>
						Patientenauswahl
					</DropdownMenuItem>
					<DropdownMenuItem
						key="practitioner_select"
						onClick={() => onSelect("practitioner_select")}
						className="cursor-pointer"
					>
						Behandlerauswahl
					</DropdownMenuItem>
					<DropdownMenuSub>
						<DropdownMenuSubTrigger>Auftrag</DropdownMenuSubTrigger>
						<DropdownMenuPortal>
							<DropdownMenuSubContent>
								{FIELD_CATEGORIES["Auftrag"].map((fieldId) => {
									const field = FIELD_REGISTRY[fieldId];
									return (
										<DropdownMenuItem
											key={fieldId}
											onClick={() => onSelect(fieldId)}
											className="cursor-pointer"
										>
											{field?.label || fieldId}
										</DropdownMenuItem>
									);
								})}
							</DropdownMenuSubContent>
						</DropdownMenuPortal>
					</DropdownMenuSub>
					<DropdownMenuSub>
						<DropdownMenuSubTrigger>
							Verrechnung
						</DropdownMenuSubTrigger>
						<DropdownMenuPortal>
							<DropdownMenuSubContent>
								{FIELD_CATEGORIES["Verrechnung"].map(
									(fieldId) => {
										const field = FIELD_REGISTRY[fieldId];
										return (
											<DropdownMenuItem
												key={fieldId}
												onClick={() =>
													onSelect(fieldId)
												}
												className="cursor-pointer"
											>
												{field?.label || fieldId}
											</DropdownMenuItem>
										);
									}
								)}
							</DropdownMenuSubContent>
						</DropdownMenuPortal>
					</DropdownMenuSub>
					<DropdownMenuSub>
						<DropdownMenuSubTrigger>
							Patienteninformationen
						</DropdownMenuSubTrigger>
						<DropdownMenuPortal>
							<DropdownMenuSubContent>
								{FIELD_CATEGORIES["Patient"].map((fieldId) => {
									const field = FIELD_REGISTRY[fieldId];
									return (
										<DropdownMenuItem
											key={fieldId}
											onClick={() => onSelect(fieldId)}
											className="cursor-pointer"
										>
											{field?.label || fieldId}
										</DropdownMenuItem>
									);
								})}
							</DropdownMenuSubContent>
						</DropdownMenuPortal>
					</DropdownMenuSub>
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	);
};
